/**
 * SEO Atom Component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/adding-common-features/adding-seo-component
 */

import React from "react"
import { useSiteMetadata } from "../../../hooks/useSiteMetadata"

const Seo = ({
  title,
  description,
  image,
  imageAltText,
  pathname,
  lang,
  doNotSearch,
  children,
}) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    lang: defaultLang,
    author,
    image: defaultImage,
    siteUrl,
  } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    siteLanguage: lang || defaultLang,
    siteCreator: author,
    image: image || defaultImage,
    imageAltText: imageAltText || `Bio-Futures for Transplanetary Habitats`,
    url: `${siteUrl}${pathname ? pathname : ""}`,
    doNotSearch: doNotSearch || false,
  }

  return (
    <>
      <html lang={seo.siteLanguage} />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="author" content={seo.siteCreator} />
      {/* TODO: Add a Google verification token
      <meta name="google-site-verification" content=""></meta> */}

      {/* Open Graph Card */}
      {/* "og:type" added as child */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={seo.imageAltText} />
      <meta property="og:url" content={seo.url} />
      <meta
        property="og:site_name"
        content="Bio-Futures for Transplanetary Habitats"
      />
      {/* Twitter / X Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:image:alt" content={seo.imageAltText} />
      <meta name="twitter:creator" content="@Bio_Futures_" />
      {/* For Crawler Bots */}
      <meta
        name="robots"
        content={doNotSearch ? `noindex,nofollow` : `index,follow`}
      />
      {/* Open Graph Card type information is added as children:
      eg: <meta property="og:type" content="article" />
      options: 
      website `str`
      profile + profile:first_name `str` + profile:last_name `str`
      article + article:author [arr] + article:tag [arr] */}
      {/* CSP content settings for storyblok to work as a frame ancestor within the storybook powered design system docs  */}
      {/* <meta
        http-equiv="Content-Security-Policy"
        content="frame-ancestors https://app.storyblok.com"
      /> */}
      {children}
    </>
  )
}

export default Seo
